enum keycode {
  ENTER = 'Enter',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
}

export function handleEnterKeyPress(e: any, handleFunction: any) {
  if (e.isComposing || e.keyCode === 229) return;
  if (e.key === keycode.ENTER && e.shiftKey) return;

  if (e.key === keycode.ENTER) {
    handleFunction(e);
  }
}
